<div [formGroup]="rangeFormGroup">
  <div class="label-filter">
    <label class="form-field__label" [attr.for]="filter.key">{{ filter.value }}</label>
    <div *ngIf="isLandingPage" miq-filter-option [isReports]="isReport" [filter]="filter" [form]="form"></div>
  </div>
  <div class="form-field__container" [ngSwitch]="filter.inputType">
    <!-- DATES -->
    <div *ngSwitchCase="'date'" class="flex-form">
      <mat-form-field appearance="outline">
        <input
          matInput
          [disabled]="fromControl.disabled"
          autocomplete="no-autofill"
          readonly
          formControlName="from"
          [matDatepicker]="fromRangeDatePicker"
          [placeholder]="'recordsSearch.from' | xTranslate"
          (dateChange)="dateEvent('from', $event)"
          [max]="maxDate"
        />
        <mat-datepicker-toggle matSuffix [for]="fromRangeDatePicker"></mat-datepicker-toggle>
        <em
          *ngIf="filter.inputType === 'date' && displayFromClearButton"
          class="value-clear pi pi-times-circle filters-date-picker-clear"
          (click)="clearDateFilter('from'); $event.stopPropagation()"
        ></em>
        <mat-datepicker #fromRangeDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <input
          matInput
          autocomplete="no-autofill"
          readonly
          [disabled]="toControl.disabled"
          formControlName="to"
          [matDatepicker]="toRangeDatePicker"
          [placeholder]="'recordsSearch.to' | xTranslate"
          (dateChange)="dateEvent('to', $event)"
          [min]="minDate"
        />
        <mat-datepicker-toggle matSuffix [for]="toRangeDatePicker"></mat-datepicker-toggle>
        <em
          *ngIf="filter.inputType === 'date' && displayToClearButton"
          class="value-clear pi pi-times-circle filters-date-picker-clear"
          (click)="clearDateFilter('to'); $event.stopPropagation()"
        ></em>
        <mat-datepicker #toRangeDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- MAXVALUE -->
    <div *ngSwitchCase="'maxvalue'">
      <div [ngSwitch]="filter.dataType">
        <div *ngSwitchCase="'date' || 'timestamp with time zone'">
          <mat-form-field appearance="outline">
            <input
              matInput
              autocomplete="no-autofill"
              readonly
              [disabled]="toControl.disabled"
              formControlName="to"
              [matDatepicker]="maxValueDatePicker"
              [placeholder]="'recordsSearch.chooseDate' | xTranslate"
            />
            <mat-datepicker-toggle matSuffix [for]="maxValueDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #maxValueDatePicker></mat-datepicker>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" *ngSwitchDefault>
          <div>
            <input
              matInput
              autocomplete="no-autofill"
              formControlName="to"
              [placeholder]="'recordsSearch.max' | xTranslate"
              [type]="filter.dataType === 'numeric' ? 'number' : 'text'"
            />
          </div>
        </mat-form-field>
      </div>
    </div>

    <!-- MINVALUE -->
    <div *ngSwitchCase="'minvalue'">
      <div [ngSwitch]="filter.dataType">
        <div *ngSwitchCase="'date' || 'timestamp with time zone'">
          <mat-form-field appearance="outline">
            <input
              matInput
              autocomplete="no-autofill"
              readonly
              [disabled]="fromControl.disabled"
              formControlName="from"
              [matDatepicker]="maxValueDatePicker"
              [placeholder]="'recordsSearch.chooseDate' | xTranslate"
            />
            <mat-datepicker-toggle matSuffix [for]="maxValueDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #maxValueDatePicker></mat-datepicker>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" *ngSwitchDefault>
          <div>
            <input
              matInput
              autocomplete="no-autofill"
              [disabled]="toControl.disabled"
              [placeholder]="'recordsSearch.min' | xTranslate"
              formControlName="from"
              [type]="filter.dataType === 'numeric' ? 'number' : 'text'"
            />
          </div>
        </mat-form-field>
      </div>
    </div>

    <!-- For filters with dataType as numeric or integer -->
    <div *ngSwitchCase="'number'" class="flex-form">
      <mat-form-field floatLabel="never" appearance="outline">
        <input
          matInput
          miqOnlyNumbers
          [restrictedKeyCodes]="restrictedKeyCodes"
          [allowedKeyCodes]="allowedKeyCodes"
          [readonly]="fromControl.disabled"
          autocomplete="no-autofill"
          [placeholder]="'recordsSearch.min' | xTranslate"
          formControlName="from"
          [type]="filter.inputType"
          (keydown.enter)="updateForm($event, 'from')"
      /></mat-form-field>

      <mat-form-field floatLabel="never" appearance="outline">
        <input
          matInput
          miqOnlyNumbers
          [restrictedKeyCodes]="restrictedKeyCodes"
          [allowedKeyCodes]="allowedKeyCodes"
          [readonly]="toControl.disabled"
          autocomplete="no-autofill"
          [placeholder]="'recordsSearch.max' | xTranslate"
          formControlName="to"
          [type]="filter.inputType"
          (keydown.enter)="updateForm($event, 'to')"
      /></mat-form-field>
    </div>

    <!-- Year selector-->
    <div *ngSwitchCase="'year'" class="flex-form">
      <miq-year-picker
        id="from"
        class="filters-year-picker"
        [date]="fromControl.value"
        [disabled]="fromControl.disabled"
        [placeholder]="'recordsSearch.from' | xTranslate"
        [maxDate]="maxDate"
        [disableYearBoundsValidation]="true"
        (selectionChange)="onYearSelected($event)"
        (clearIcon)="clearDateFilter($event.id)"
      ></miq-year-picker>

      <miq-year-picker
        id="to"
        class="filters-year-picker"
        [date]="toControl.value"
        [disabled]="toControl.disabled"
        [placeholder]="'recordsSearch.to' | xTranslate"
        [minDate]="minDate"
        [disableYearBoundsValidation]="true"
        (selectionChange)="onYearSelected($event)"
        (clearIcon)="clearDateFilter($event.id)"
      ></miq-year-picker>
    </div>

    <!-- ALL OTHERS, for example where inputType = text -->
    <div *ngSwitchDefault class="flex-form">
      <mat-form-field floatLabel="never" appearance="outline">
        <input
          matInput
          [readonly]="fromControl.disabled"
          autocomplete="no-autofill"
          [placeholder]="'recordsSearch.min' | xTranslate"
          formControlName="from"
          [type]="filter.inputType"
          (keydown.enter)="updateForm($event, 'from')"
      /></mat-form-field>

      <mat-form-field floatLabel="never" appearance="outline">
        <input
          matInput
          [readonly]="toControl.disabled"
          autocomplete="no-autofill"
          [placeholder]="'recordsSearch.max' | xTranslate"
          formControlName="to"
          [type]="filter.inputType"
          (keydown.enter)="updateForm($event, 'to')"
      /></mat-form-field>
    </div>
  </div>
</div>
